__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "billpay";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@progress/kendo-licensing", "1.6.0", () => (() => (__webpack_require__(1517))), 1);
			register("@redstone/redstone-identity", "3.3.8", () => (() => (__webpack_require__(1535))), 1);
			register("@redstone/redstone-ux", "0.12.17", () => (() => (__webpack_require__(4960))), 1);
			register("@tanstack/react-query-devtools", "4.40.0", () => (() => (__webpack_require__(9382))), 1);
			register("@tanstack/react-query", "4.40.0", () => (() => (__webpack_require__(6104))), 1);
			register("axios", "0.27.2", () => (() => (__webpack_require__(854))), 1);
			register("moment-timezone", "0.5.48", () => (() => (__webpack_require__(4348))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-number-format", "5.4.4", () => (() => (__webpack_require__(9577))), 1);
			register("react-router-dom", "6.30.3", () => (() => (__webpack_require__(3245))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			register("universal-cookie", "7.2.2", () => (() => (__webpack_require__(4750))), 1);
			register("web-vitals", "1.1.2", () => (() => (__webpack_require__(6453))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};